export const TOGGLE_VERSION = "TOGGLE_VERSION";

export const toggleVersion = () => ({
    type: TOGGLE_VERSION,
});
